(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  const curatedCollections = ['all', 'one-piece', 'jujutsu-kaisen', 'bleach', 'attack-on-titan', 'chainsaw-man', 'jojos-bizarre-adventure', 'berserk', 'overlord'];
  const collectionHandle = url.pathname.replace(/\/$/, '').split('/collections/')[1];
  if (curatedCollections.includes(collectionHandle) && url.searchParams.get('sort_by') === 'best-selling') {
    url.searchParams.set('sort_by', 'manual');
    url.searchParams.delete('page');
    window.location.replace(url.href);
  }
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
